var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item',{attrs:{"link":"","to":_vm.subMenuItem.path}},[_c('v-list-item-icon',{staticStyle:{"padding-left":"64px"}},[_c('icon',{attrs:{"icon":_vm.subMenuItem.icon}})],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.subMenuItem.title))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }